<template>
  <div class="provider-info">
    <div class="provider-name">{{ providerName }}</div>
    <div v-if="providerCode" class="provider-code">
      <span class="code-label">Mã NCC:</span>
      <span class="code-value">{{ providerCode }}</span>
    </div>
    <div v-if="providerTaxCode" class="provider-tax-code">
      <span class="tax-label">MST:</span>
      <span class="tax-value">{{ providerTaxCode }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProviderInfo',
  props: {
    providerName: {
      type: String,
      required: true,
    },
    providerCode: {
      type: String,
      default: '',
    },
    providerTaxCode: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.provider-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  line-height: 1.4;
}

.provider-name {
  color: #007bff;
  margin-bottom: 2px;
}

.provider-code,
.provider-tax-code {
  margin-top: 2px;
  line-height: 1.3;
  font-size: 12px;
}

.code-label,
.tax-label {
  color: #000;
  margin-right: 4px;
}

.code-value,
.tax-value {
  color: #666;
}
</style>
